import { combineReducers } from "redux-immutable";

import CourseStatStateSlice from "../../models/state/courseStats";
import { courseStatsMeta } from "./state/meta";
import { courseStats } from "./state/stats";

export default combineReducers(
  {
    meta: courseStatsMeta,
    stats: courseStats
  },
  () => new CourseStatStateSlice() as any
);
